// 에셋 로딩 상태(렌더가 쓰고 UI가 읽는다). 시작 버튼은 ready 또는 failed가 된 뒤 활성화한다.
export interface AssetStatus {
  /** 0..1 */
  progress: number;
  ready: boolean;
  /** 실패하면 캡슐 그레이박스로 대체한다 */
  failed: boolean;
  /** 실패(오류·시간 초과) 뒤 다시 받기. 실패 상태에서만 채워진다(타이틀의 '다시 시도' 버튼) */
  retry: (() => void) | null;
  /** 캐릭터 모델 받기 시도 횟수(첫 시도 1) */
  attempts: number;
}

export const assetStatus: AssetStatus = { progress: 0, ready: false, failed: false, retry: null, attempts: 0 };

/** 캐릭터 모델이 이 시간 안에 오지 않으면 실패로 보고 간이 모델 시작·다시 시도를 연다(무한 로딩 방지) */
export const KAEL_LOAD_TIMEOUT_MS = 30000;
